<!-- Hero (Figma BLUE ASSIST 2025 Final · node 13857:17805 · base 1440x887) -->
<section class="hero">
  <div class="hero__inner">
    <!-- Hero móvil (<768, Figma 14034:43928): como el banner original, con el botón en azul -->
    <div class="hero__mobile rv-grp">
      <button type="button" class="hero__mcta rv" (click)="goQuote()"><span>Cotizar Seguro</span><svg class="hero__mcta-ico" viewBox="0 0 24 48" aria-hidden="true"><path d="M19.6 33L13.3 26.7C12.8 27.1 12.225 27.4167 11.575 27.65C10.925 27.8833 10.2333 28 9.5 28C7.68333 28 6.146 27.371 4.888 26.113C3.62933 24.8543 3 23.3167 3 21.5C3 19.6833 3.62933 18.1457 4.888 16.887C6.146 15.629 7.68333 15 9.5 15C11.3167 15 12.8543 15.629 14.113 16.887C15.371 18.1457 16 19.6833 16 21.5C16 22.2333 15.8833 22.925 15.65 23.575C15.4167 24.225 15.1 24.8 14.7 25.3L21 31.6L19.6 33ZM9.5 26C10.75 26 11.8127 25.5627 12.688 24.688C13.5627 23.8127 14 22.75 14 21.5C14 20.25 13.5627 19.1873 12.688 18.312C11.8127 17.4373 10.75 17 9.5 17C8.25 17 7.18733 17.4373 6.312 18.312C5.43733 19.1873 5 20.25 5 21.5C5 22.75 5.43733 23.8127 6.312 24.688C7.18733 25.5627 8.25 26 9.5 26Z" fill="#fff"/></svg></button>
      <p class="hero__mtitle rv">El <strong>seguro de viaje</strong> que se adapta a ti.</p>
      <p class="hero__msub rv">Blue Assist by BAC Financial</p>
    </div>
    <div class="hero__media">
      <video #heroVideo class="hero__video" [src]="heroVideoSrc" [attr.poster]="heroPoster" autoplay muted loop playsinline preload="auto" [muted]="true" aria-hidden="true"></video>
    </div>
    <div class="hero__gradient"></div>
    <div class="hero__content">
      <h1 class="hero__title">
        <span class="hero__line"><span class="hero__reveal">El seguro</span></span>
        <span class="hero__line hero__line--accent"><span class="hero__reveal"><em>de viaje</em> que</span></span>
        <span class="hero__line"><span class="hero__reveal">se adapta a ti</span></span>
      </h1>
      <p class="hero__text">Blue Assist, asistencia al viajero con coberturas flexibles y el respaldo de BAC Financial.</p>
      <div class="hero__actions">
        <button type="button" class="hero__cta" (click)="goQuote()">Cotizar Seguro</button>
      </div>
    </div>
  </div>
</section>

<!-- Sección "4 datos" (diseño final Figma 13969:36387, 2026-10-18): imagen del render a la izquierda + titular y cuatro cifras -->
<section class="facts-sec" aria-label="Por qué Blue Assist">
  <div class="facts-img">
    <!-- Animación "tarjetas en el cielo" (2026-10-18): página aislada en assets/anim/tarjetas (motor compartido con assets/anim/beneficios); sustituye a la imagen tarjetas-blue-assist.jpg -->
    <iframe class="facts-anim" src="/assets/anim/tarjetas/index.html" title="Animación: tarjetas Blue Assist flotando en el cielo con una pelota y la torre Eiffel" loading="lazy" scrolling="no" tabindex="-1" aria-hidden="true"></iframe>
  </div>
  <div class="facts-txt">
    <h2 class="facts-h rv-grp"><span class="rv-line"><span class="rv-up">Viaja con <em>la tranquilidad</em></span></span><span class="rv-line"><span class="rv-up">de Blue Assist</span></span></h2>
    <ul class="facts-grid rv-grp">
      <li class="rv"><div class="facts-num"><span data-count="0">0</span><small>deducible</small></div><b>Sin deducible y con preexistencias</b><span>Incluidas desde el primer día.</span></li>
      <li class="rv"><div class="facts-num"><span data-count="84">84</span><small>años</small></div><b>Sin fronteras de edad</b><span>Cubierto donde otros seguros se quedan cortos.</span></li>
      <li class="rv"><div class="facts-num"><span data-count="1">1</span><small>cobertura</small></div><b>Médica y de viaje</b><span>Las dos asistencias en un solo plan, sin costo extra.</span></li>
      <li class="rv"><div class="facts-num"><span data-count="24">24</span><small>/7</small></div><b>Asistencia inmediata</b><span>Atención médica incluso en tu hotel.</span></li>
    </ul>
  </div>
</section>
<!-- Beneficios Blue Assist -->
<div class="beneficios-blue-assist home-beneficios-blue-assist" id="forBox">
  <div class="container beneficios-container">
    <div class="row">
      <div class="col-md-6 col-lg-7">
        <div class="beneficios-left-section rv-grp">
          <div class="beneficios-title-section">
            <h1><span class="rv-line"><span class="rv-up"><em class="accent">Protección integral</em> para viajeros,</span></span><span class="rv-line"><span class="rv-up">más allá de la estabilización médica</span></span></h1>
          </div>
          <!-- Beneficios: pestañas + filas con icono + grupos plegables (propuesta 4, 2026-10-16) -->
          <div class="benef" id="beneficios-accordion1">
            <svg class="benef-defs" width="0" height="0" aria-hidden="true" focusable="false">
              <defs>
                <symbol id="bi-hospital" viewBox="0 0 24 24"><path d="M3 21V8l9-5 9 5v13M3 21h18M9 21v-5h6v5M12 9v4M10 11h4"/></symbol>
                <symbol id="bi-tooth" viewBox="0 0 24 24"><path d="M7 3c2 0 3 1 5 1s3-1 5-1c3 0 4 3 3 6-1 2-2 3-2 6-.3 3-1 6-2.5 6S14 17 12 17s-2 4-3.5 4S6 18 5.5 15c0-3-1-4-2-6C2.5 6 4 3 7 3z"/></symbol>
                <symbol id="bi-plane" viewBox="0 0 24 24"><path d="M2 16l20-7-5 9-4-2-3 3-1-4z"/><path d="M22 9L9 12"/></symbol>
                <symbol id="bi-ambulance" viewBox="0 0 24 24"><path d="M3 7h11v10H3zM14 10h4l3 3v4h-7"/><circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/><path d="M8.5 10v4M6.5 12h4"/></symbol>
                <symbol id="bi-bed" viewBox="0 0 24 24"><path d="M3 18V8M3 14h18v4M3 12h18v2M7 12V9h5v3"/></symbol>
                <symbol id="bi-heart" viewBox="0 0 24 24"><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"/><path d="M5 12h4l1.5-3 2 6 1.5-3h5"/></symbol>
                <symbol id="bi-bag" viewBox="0 0 24 24"><rect x="4" y="8" width="16" height="12" rx="2"/><path d="M9 8V5h6v3M4 13h16"/></symbol>
                <symbol id="bi-user" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></symbol>
                <symbol id="bi-home" viewBox="0 0 24 24"><path d="M3 11l9-7 9 7v9H3z"/><path d="M10 20v-6h4v6"/></symbol>
                <symbol id="bi-info" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8h.01"/></symbol>
                <symbol id="bi-chev" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></symbol>
              </defs>
            </svg>

            <div class="benef-tabs rv" role="tablist" aria-label="Tipo de asistencia">
              <button type="button" role="tab" [attr.aria-selected]="benefitTab === 'medica'" [class.is-active]="benefitTab === 'medica'" (click)="setBenefitTab('medica')">Asistencia Médica</button>
              <button type="button" role="tab" [attr.aria-selected]="benefitTab === 'viajero'" [class.is-active]="benefitTab === 'viajero'" (click)="setBenefitTab('viajero')">Asistencia al viajero</button>
            </div>

            <div class="benef-panels">
              <!-- Asistencia Médica -->
              <div class="benef-panel" [class.is-active]="benefitTab === 'medica'" role="tabpanel">
                <p class="benef-intro rv"><svg><use href="#bi-info"/></svg>Por accidente o emergencia médica en un viaje fuera del país de residencia. Incluida en todos los planes; los límites varían según la cobertura máxima elegida.</p>
                <!-- Carrusel 3 + 3 (2 + 2 + 2 en movil): rota cada 6 s, se pausa con el ratón encima y se detiene al usar flechas, puntos o al abrir un grupo -->
                <div class="benef-carousel" (mouseenter)="pauseBenefitRotation()" (mouseleave)="resumeBenefitRotation()">
                  <!-- Lista unica; paginas de 3 (escritorio) o 2 (movil) segun benefPageSize -->
                  <ul class="benef-rows benef-list" [class.is-fading]="benefFading">
                      <li class="benef-grp rv" [class.is-on]="benefOn(0)" [class.is-last]="benefLast(0)" [attr.data-open]="!!benefitOpen['hosp']">
                        <button type="button" class="benef-grp-h" [attr.aria-expanded]="!!benefitOpen['hosp']" (click)="toggleBenefit('hosp')">
                          <i class="benef-ico"><svg><use href="#bi-hospital"/></svg></i>
                          <div><b>Servicios hospitalarios</b><small>Estabilización y tratamiento de una emergencia. Ver qué incluye</small></div>
                          <i class="benef-chev"><svg><use href="#bi-chev"/></svg></i>
                        </button>
                        <div class="benef-grp-b"><ul class="benef-chips"><li>Telemedicina o visita a domicilio</li><li>Médicos y especialistas</li><li>Emergencia u hospitalización</li><li>Medicamentos prescritos</li></ul></div>
                      </li>
                      <li class="rv" [class.is-on]="benefOn(1)" [class.is-last]="benefLast(1)"><i class="benef-ico"><svg><use href="#bi-tooth"/></svg></i><div><b>Emergencia dental</b><small>Atención del dolor agudo o la lesión durante el viaje.</small></div></li>
                      <li class="rv" [class.is-on]="benefOn(2)" [class.is-last]="benefLast(2)"><i class="benef-ico"><svg><use href="#bi-plane"/></svg></i><div><b>Repatriación por emergencia médica</b><small>Regreso al país de residencia cuando lo indique el médico tratante.</small></div></li>
                      <li class="rv" [class.is-on]="benefOn(3)" [class.is-last]="benefLast(3)"><i class="benef-ico"><svg><use href="#bi-ambulance"/></svg></i><div><b>Traslado terrestre o aéreo</b><small>Hasta el centro médico adecuado más cercano.</small></div></li>
                      <li class="rv" [class.is-on]="benefOn(4)" [class.is-last]="benefLast(4)"><i class="benef-ico"><svg><use href="#bi-bed"/></svg></i><div><b>Estadía en hotel por convalecencia</b><small>Cuando la prescribe el médico tras una emergencia.</small></div></li>
                      <li class="rv" [class.is-on]="benefOn(5)" [class.is-last]="benefLast(5)"><i class="benef-ico"><svg><use href="#bi-heart"/></svg></i><div><b>Condiciones médicas preexistentes</b><small>Según la cobertura seleccionada en tu plan.</small></div></li>
                  </ul>
                  <div class="benef-nav rv">
                    <button type="button" class="benef-arrow benef-arrow--prev" aria-label="Beneficios anteriores" (click)="goBenefitPage(benefitPage - 1, true)"><svg><use href="#bi-chev"/></svg></button>
                    <div class="benef-dots">
                      <button type="button" *ngFor="let p of benefPageList" [class.is-active]="benefitPage === p" [attr.aria-label]="'Beneficios, página ' + (p + 1)" (click)="goBenefitPage(p, true)"></button>
                    </div>
                    <button type="button" class="benef-arrow benef-arrow--next" aria-label="Más beneficios" (click)="goBenefitPage(benefitPage + 1, true)"><svg><use href="#bi-chev"/></svg></button>
                  </div>
                </div>
              </div>
              <!-- Asistencia al viajero -->
              <div class="benef-panel" [class.is-active]="benefitTab === 'viajero'" role="tabpanel">
                <p class="benef-intro rv"><svg><use href="#bi-info"/></svg>Incluida en todos los planes; los límites varían según la cobertura máxima elegida.</p>
                <ul class="benef-rows">
                  <li class="benef-grp rv" [attr.data-open]="!!benefitOpen['viaje']">
                    <button type="button" class="benef-grp-h" [attr.aria-expanded]="!!benefitOpen['viaje']" (click)="toggleBenefit('viaje')">
                      <i class="benef-ico"><svg><use href="#bi-bag"/></svg></i>
                      <div><b>Beneficios durante el viaje</b><small>Demoras, equipaje, pasaporte y vehículo alquilado. Ver los 7 beneficios</small></div>
                      <i class="benef-chev"><svg><use href="#bi-chev"/></svg></i>
                    </button>
                    <div class="benef-grp-b"><ul class="benef-chips"><li>Viaje demorado o cancelado</li><li>Pérdida de conexión de vuelo</li><li>Localización de equipaje</li><li>Pérdida definitiva de equipaje</li><li>Pérdida de pasaporte</li><li>Demora de equipaje mayor a 24 h</li><li>Remolque de vehículo alquilado</li></ul></div>
                  </li>
                  <li class="benef-grp rv" [attr.data-open]="!!benefitOpen['acomp']">
                    <button type="button" class="benef-grp-h" [attr.aria-expanded]="!!benefitOpen['acomp']" (click)="toggleBenefit('acomp')">
                      <i class="benef-ico"><svg><use href="#bi-user"/></svg></i>
                      <div><b>Acompañamiento y regreso</b><small>Repatriación, acompañante y regreso anticipado. Ver los 4 beneficios</small></div>
                      <i class="benef-chev"><svg><use href="#bi-chev"/></svg></i>
                    </button>
                    <div class="benef-grp-b"><ul class="benef-rows benef-rows--inner">
                      <li class="rv"><i class="benef-ico"><svg><use href="#bi-plane"/></svg></i><div><b>Repatriación de restos</b></div></li>
                      <li class="rv"><i class="benef-ico"><svg><use href="#bi-user"/></svg></i><div><b>Regreso del acompañante asegurado</b><small>Menor de 15 años o mayor de 75 años.</small></div></li>
                      <li class="rv"><i class="benef-ico"><svg><use href="#bi-bed"/></svg></i><div><b>Estadía en hotel para un acompañante</b><small>Hasta 10 días.</small></div></li>
                      <li class="rv"><i class="benef-ico"><svg><use href="#bi-home"/></svg></i><div><b>Regreso por fallecimiento de familiar inmediato</b></div></li>
                    </ul></div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-5" style="display: flex; align-items: flex-end;">
        <div class="beneficios-right-section">
          <img src="/assets/img/big-logo.png" alt="Blue Assist" class="big-logo">
          <div class="beneficios-lady-container"><img src="/assets/img/beneficios-lady.png" alt="Blue Assist" class="beneficios-lady"></div>
        </div>
      </div>
    </div>
  </div>
</div> 
<!-- Beneficios Blue Assist -->
<!-- Protección section -->
<div class="proteccion-section">
  <div class="container proteccion-container">
    <div class="row">
      <div class="col-md-7">
        <div class="web-none proteccion-right-section rv-grp">
          <h2><span class="rv-line"><span class="rv-up"><em class="accent">Protección a tu medida;</em></span></span><span class="rv-line"><span class="rv-up">coberturas opcionales para cada necesidad</span></span></h2>
          <!-- <a href="javascript:void(0)" (click)="goQuote()" class="btn-primary btn continue-btn-steps" title="Cotizar Seguro">Cotizar Seguro</a> -->
        </div>
        <div class="proteccion-left-section">
          <!-- Animación del teléfono (coberturas opcionales por persona): página aislada en assets/anim/beneficios, compilada de antemano -->
          <iframe class="proteccion-anim" src="/assets/anim/beneficios/index.html" title="Animación: cómo se añaden coberturas opcionales por persona" loading="lazy" scrolling="no" tabindex="-1" aria-hidden="true"></iframe>
        </div>
      </div>
      <div class="col-md-5">
        <div class="proteccion-right-section rv-grp">
          <div class="proteccion-title-container">
            <h2 class="mobile-none"><span class="rv-line"><span class="rv-up"><em class="accent">Protección a tu medida;</em></span></span><span class="rv-line"><span class="rv-up">coberturas opcionales para cada necesidad</span></span></h2>
          </div>
          <svg class="benef-defs" width="0" height="0" aria-hidden="true" focusable="false">
            <defs>
              <symbol id="po-heart" viewBox="0 0 24 24"><path d="M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z"/><path d="M5 12h4l1.5-3 2 6 1.5-3h5"/></symbol>
              <symbol id="po-sport" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M4.5 8.5c3 1 5 3 6 7.5M19.5 8.5c-3 1-5 3-6 7.5M12 3c-1 3-1 6 0 9 1 3 1 6 0 9"/></symbol>
              <symbol id="po-cancel" viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4M10 14l4 4M14 14l-4 4"/></symbol>
              <symbol id="po-mom" viewBox="0 0 24 24"><circle cx="12" cy="6" r="3"/><path d="M9 21v-5a3 3 0 0 1 6 0v5M7 14a5 5 0 0 1 10 0"/></symbol>
              <symbol id="po-paw" viewBox="0 0 24 24"><circle cx="7" cy="9" r="2"/><circle cx="17" cy="9" r="2"/><circle cx="10" cy="5" r="2"/><circle cx="14" cy="5" r="2"/><path d="M12 11c-3 0-6 3-6 6a3 3 0 0 0 3 3c1.5 0 2-1 3-1s1.5 1 3 1a3 3 0 0 0 3-3c0-3-3-6-6-6z"/></symbol>
              <symbol id="po-legal" viewBox="0 0 24 24"><path d="M12 3v18M5 21h14M6 7l6-2 6 2M3 13l3-6 3 6a3 3 0 0 1-6 0zM15 13l3-6 3 6a3 3 0 0 1-6 0z"/></symbol>
            </defs>
          </svg>
          <!-- Lista de opcionales con el mismo patrón que las filas de beneficios (icono + título + línea). Textos descriptivos: propuesta, pendiente de validar -->
          <ul class="po-list">
            <li id="proteccionLi1" class="rv"><i class="benef-ico"><svg><use href="#po-heart"/></svg></i><div><b>Preexistencias <span class="po-note">(ampliación de cobertura)</span></b><small>Amplía el límite de tus condiciones preexistentes.</small></div></li>
            <li id="proteccionLi2" class="rv"><i class="benef-ico"><svg><use href="#po-sport"/></svg></i><div><b>Deportes Peligrosos</b><small>Emergencias médicas al practicar deportes de riesgo, profesionales o amateur.</small></div></li>
            <li id="proteccionLi3" class="rv"><i class="benef-ico"><svg><use href="#po-cancel"/></svg></i><div><b>Cancelación del Viaje</b><small>Protección si debes cancelar antes de salir.</small></div></li>
            <li id="proteccionLi4" class="rv"><i class="benef-ico"><svg><use href="#po-mom"/></svg></i><div><b>Futura Mamá</b><small>Cobertura para emergencias durante el embarazo.</small></div></li>
            <li id="proteccionLi5" class="rv"><i class="benef-ico"><svg><use href="#po-paw"/></svg></i><div><b>Asistencia Mascotas</b><small>Atención veterinaria de urgencia para tu mascota.</small></div></li>
            <li id="proteccionLi6" class="rv"><i class="benef-ico"><svg><use href="#po-legal"/></svg></i><div><b>Asistencia Legal VIP</b><small>Asesoría legal en el extranjero cuando la necesites.</small></div></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Protección section -->

<!-- <div class="container-fluid px-0">  
  <div class="main-img-style d-flex flex-column justify-content-end"></div>
  <div class="py-5"></div>
  <div class="row pt-5 w-100">
    <div class="px-0 w-100 location-img-style">
      <img
        [attr.src]="'/assets/external/Location-Blue.png'"
        class="img-fluid"
        style="height: 135px"
      />
    </div>
  </div>
  <div class="row mx-0 align-center-center">
    <div class="col-10 col-md-10 col-lg-9 col-xl-9 col-xxl-7" id="becausesection">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle shadow-lg">
            <div class="card-body p-5 align-content-center">
              <span class="tittle-card-style"
                >SIN deducible y con preexistencias.</span
              >
              <p class="card-body-text-style mt-2">
                Incluye preexistencias y servicios no médicos..
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div
            class="card custom-card-middle shadow-lg custom-card-middle-blue"
          >
            <div class="card-body p-5 align-content-center">
              <span class="tittle-card-style"
                >Sin Fronteras hasta los 84 años de edad.</span
              >
              <p class="card-body-text-style mt-2">
                Ofrece beneficios que, por lo general, no tienen los seguros de
                salud lovcales ni los de las tarjetas de crédito..
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div
            class="card custom-card-middle shadow-lg custom-card-middle-all-blue"
          >
            <div class="card-body p-5 align-content-center">
              <span class="tittle-card-style" style="color: #fff"
                >Coberturas precisas para todo tipo de viaje.</span
              >
              <p class="card-body-text-style mt-2" style="color: #fff">
                Coberturas planteadas para cubrir la gran mayoría de imprevistos
                que puedan surgir en el extranjero.
              </p>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle shadow-lg">
            <div class="card-body p-5 align-content-center">
              <span class="tittle-card-style">Servicio 24 horas</span>
              <p class="card-body-text-style mt-2">
                Asistencia médica en la comodidad del hotel o lugar de
                hospedaje.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto d-flex align-items-start align-tower-md">
      <img
        [attr.src]="'/assets/external/eiffelwhite.png'"
        class="img-fluid img-tower"
      />
    </div>
  </div>
  <div class="py-5"></div>
  <div class="row mx-0 pt-5 align-center-center">
    <div class="col-12 col-md-10 col-lg-9" id="benefitsecction">
      <div class="row justify-content-center">
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 pb-5">
          <div
            class="card custom-card-middle shadow-lg background-grey"
            [ngClass]="{ expanded: showCoverTwo || showCover }"
          >
            <div class="card-body px-5 py-0 align-center-center">
              <div class="row w-100 d-flex">
                <div class="col-6 d-flex flex-column pt-5">
                  <p class="text-card-blue-style pt-5">
                    Beneficios Blue Assist
                  </p>
                  <span class="text-card-blue-style" style="font-weight: 500"
                    >Incluido en todos los planes, límites variables de acuerdo
                    a cobertura máxima elegida.
                  </span>
                  <div class="form-group mt-3 w-50">
                    <button
                      type="button"
                      class="btn btn-primary continue-btn-steps py-3"
                      data-bs-toggle="modal"
                      (click)="goQuote()"
                    >
                      Cotizar
                    </button>
                  </div>
                  <div class="basketball-position">
                    <img
                      alt="downIcon"
                      src="/assets/external/eiffelpurpple43402-zuxi-300w.png"
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="card-first-img-style"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 pb-5">
          <div class="row">
            <div class="col-12 mb-3">
              <div
                class="card custom-card-middle-right shadow-lg custom-card-middle-blue py-2"
              >
                <div class="card-body p-5 align-content-center">
                  <div class="tittle-card-style closeIcon-align">
                    <span>Asistencias Médicas </span>
                    <span *ngIf="showCover" (click)="showCobertura()">
                      <img
                        alt="CloseIcon"
                        src="/assets/external/icon-x-close-blue.svg"
                        class="closeIcon"
                      />
                    </span>
                  </div>
                  <p class="card-body-text-style mt-2" *ngIf="!showCover">
                    Incluido en todos los planes, límites variables de acuerdo a
                    cobertura máxima elegida.
                  </p>
                  <div
                    class="d-flex align-items-center"
                    style="cursor: pointer"
                    *ngIf="!showCover"
                    (click)="showCobertura()"
                  >
                    <span>
                      <img
                        alt="downIcon"
                        src="/assets/external/arrowdowni3402-5atj.svg"
                        class="closeIcon"
                      />
                    </span>
                    <span class="text-card-blue-style pl-2"
                      >Ver Coberturas</span
                    >
                  </div>
                  <div [ngClass]="{ 'box-expanded-effect': showCover }">
                    <span *ngIf="showCover" class="text-simple-style">
                      Por accidente o emergencia médica que se presente en un
                      viaje fuera del país de residencia. Incluido en todos los
                      planes, Límites variables de acuerdo a cobertura máxima
                      elegida.
                      <br />
                      <br />
                      Servicios hospitalarios para la estabilización y
                      tratamiento de una emergencia, incluyendo, pero sin estar
                      limitados a:
                      <br />
                      Telemedicina o visita de médico a domicilio.
                      <br />
                      Servicios de médicos y especialistas.
                      <br />
                      Servicios de emergencia u hospitalización.
                      <br />
                      Medicamentos prescritos requeridos por una emergencia.
                      <br />
                      Covid-19; Pruebas de detección medicamente necesaria y
                      estadía en el hotel 14 días
                      <br />
                      Emergencia dental.
                      <br />
                      Repatriación por emergencia médica.
                      <br />
                      Traslado terrestre o aéreo por emergencia médica.
                      <br />
                      Condiciones Médicas Pre-existentes, limitado por máxima
                      covertura.
                    </span>
                  </div>
                  <div *ngIf="showCover">
                    <span
                      class="text-card-blue-style"
                      style="cursor: pointer"
                      (click)="goBenefit()"
                      >Ver tabla de beneficios</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div
                class="card custom-card-middle-right background-dark-blue shadow-lg py-2"
              >
                <div class="card-body p-5 align-content-center">
                  <div
                    class="tittle-card-style closeIcon-align d-flex align-items-center"
                  >
                    <span style="color: #fff">Asistencias No Médicas </span>
                    <span *ngIf="showCoverTwo" (click)="showCoberturaTwo()">
                      <img
                        alt="CloseIcon"
                        src="/assets/external/icon-x-close-white-two.svg"
                        class="closeIcon"
                      />
                    </span>
                  </div>
                  <p
                    class="card-body-text-style mt-2"
                    *ngIf="!showCoverTwo"
                    style="color: #fff"
                  >
                    Incluido en todos los planes, límites variables de acuerdo a
                    cobertura máxima elegida.
                  </p>
                  <div
                    class="d-flex align-items-center"
                    style="cursor: pointer"
                    *ngIf="!showCoverTwo"
                    (click)="showCoberturaTwo()"
                  >
                    <span>
                      <img
                        alt="downIcon"
                        src="/assets/external/arrowdowni3402-7iyc.svg"
                        class="closeIcon"
                      />
                    </span>
                    <span class="text-card-blue-style pl-2" style="color: #fff"
                      >Ver Coberturas</span
                    >
                  </div>
                  <div
                    [ngClass]="{ 'box-expanded-effect': showCoverTwo }"
                    *ngIf="showCoverTwo"
                    class="text-simple-style"
                    style="color: #fff"
                  >
                    <span>
                      Repatriación de restos.
                      <br />
                      Regreso del acompañante asegurado menor de 15 años y mayor
                      de 75 años.
                      <br />
                      Estadía en hotel para un acompañante hasta 10 días.
                      <br />
                      Asistencia legal y gastos de fianza.
                      <br />
                      Regreso por fallecimiento de familiar inmediato
                      <br />
                      Regreso por pérdida catastrófrica en su docicilio
                      <br />
                      <br />
                      Beneficios durante el vieje:
                      <br />
                      Viaje demorado, cancelado.
                      <br />
                      Perdida de conexión de vuelo.
                      <br />
                      Localización de equipaje.
                      <br />
                      Pérdida definitica de equipaje.
                      <br />
                      Pérdida de pasaporte.
                      <br />
                      Demora de equipaje superior a 72 horas u a 12 días.
                      <br />
                      Servicio de remolque para vehiículo alquilado.
                    </span>
                  </div>
                  <div *ngIf="showCoverTwo">
                    <span
                      class="text-card-blue-style"
                      style="cursor: pointer; color: #fff"
                      (click)="goBenefit()"
                      >Ver tabla de beneficios</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="py-5"></div>
  <div class="row mx-0 align-center-center">
    <div class="col-10 col-md-10 col-lg-9 col-xl-9 col-xxl-9" id="optionSection">
      <div class="row justify-content-center">
        <div class="col-9 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div
            class="card custom-card-middle shadow-lg custom-card-middle-all-blue"
          >
            <div class="card-body p-5 align-content-center">
              <span class="tittle-card-style" style="color: #fff"
                >Beneficios Opcionales</span
              >
              <div>
                <p class="card-body-text-style mt-2" style="color: #fff">
                  Lorem ipsum dolor sit amet consectetur. Ullamcorper ut aliquam
                  commodo hac pharetra tristique.
                </p>
                <div>
                  <button
                    type="button"
                    class="btn btn-primary continue-btn-steps py-3 border-color-width"
                    data-bs-toggle="modal"
                    (click)="goQuote()"
                  >
                    Cotizar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle border-color-grey shadow-lg">
            <div class="card-body p-3 align-content-center">
              <div class="d-flex justify-content-center align-items-center">
                <img
                  alt="downIcon"
                  src="/assets/img/opcionales-texto-5-1500w.png"
                  class="img-fluid"
                  style="max-height: 320px"
                />
              </div>
              <p
                class="card-body-text-style text-card-blue-style mt-2 mb-1 pl-3"
              >
                Mascotas
              </p>
              <div class="d-flex justify-content-start align-items-center pl-3">
                <img
                  alt="downIcon"
                  src="/assets/external/arrowdowni3402-5atj.svg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle border-color-grey shadow-lg">
            <div class="card-body p-3 align-content-center">
              <div class="d-flex justify-content-center align-items-center">
                <img
                  alt="downIcon"
                  src="/assets/img/opcionales-texto-1.svg"
                  class="img-fluid"
                  style="max-height: 320px"
                />
              </div>
              <p
                class="card-body-text-style text-card-blue-style mt-2 mb-1 pl-3"
              >
                Practica de Deportes
              </p>
              <div class="d-flex justify-content-start align-items-center pl-3">
                <img
                  alt="downIcon"
                  src="/assets/external/arrowdowni3402-5atj.svg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-9 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle border-color-grey shadow-lg">
            <div class="card-body p-3 align-content-center">
              <div class="d-flex justify-content-center align-items-center">
                <img
                  alt="downIcon"
                  src="/assets/img/opcionales-texto-3-1500w.png"
                  class="img-fluid"
                  style="max-height: 320px"
                />
              </div>
              <p
                class="card-body-text-style text-card-blue-style mt-2 mb-1 pl-3"
              >
                Futura Mamá
              </p>
              <div class="d-flex justify-content-start align-items-center pl-3">
                <img
                  alt="downIcon"
                  src="/assets/external/arrowdowni3402-5atj.svg"
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row w-100">
    <div class="px-0 w-100 bone-img">
      <img
        [attr.src]="'/assets/external/Eiffel-PurppleNew.png'"
        class="img-fluid"
        style="height: 120px"
      />
    </div>
  </div>
  <div class="py-5"></div>
  <div class="row mx-0 align-center-center">
    <div class="col-12 col-md-10 col-lg-9" >
      <div class="row justify-content-center">
        <div class="col-12 col-md-12 col-lg-12 col-xl-3 pb-5">
          <div class="card custom-card-middle-right background-grey shadow-lg">
            <div class="card-body p-5 align-content-center">
              <span class="tittle-card-style text-card-blue-style"
                >Preguntas frecuentes</span
              >
              <div>
                <p
                  class="card-body-text-style text-card-blue-style mt-2"
                  style="font-weight: 500"
                >
                  Incluido en todos los planes, límites variables de acuerdo a
                  cobertura máxima elegida.
                </p>
                <div>
                  <button
                    type="button"
                    class="btn btn-primary continue-btn-steps py-3 btn-width"
                    data-bs-toggle="modal"
                  >
                    Haz tu consulta
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-3 pb-5">
          <div class="card custom-card-middle-right background-dark-blue shadow-lg">
            <div class="card-body px-5 py-0 align-center-center">
              <div class="row w-100 d-flex align-items-center pt-2">
                <div
                  class="col-12 d-flex flex-column align-items-center px-0 py-5"
                >
                  <div class="row w-100">
                    <div class="col-12 px-0 border-blue pb-2 align-text-plus">
                      <span class="tittle-card-style text-color-white"
                        >Asistencia Legal y Fianza</span
                      >
                      <span class="tittle-card-style tittle-circle">+</span>
                    </div>
                  </div>
                  <div class="row w-100 pt-3">
                    <div class="col-12 justify-content-start px-0">
                      <span
                        class="tittle-card-style text-color-white"
                        style="font-weight: 500"
                        >Reporte policial, orden judicial, factura original del
                        abogado y evidencia de pago.</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-12 col-lg-12 col-xl-6 pb-5">
          <div class="row">
            <div class="col-12 pb-3">
              <div
                class="card custom-card-middle-right custom-card-middle-blue-border border-grey shadow-lg"
              >
                <div class="card-body px-5 py-0 align-center-center">
                  <div class="row w-100 d-flex align-items-center pt-2">
                    <div class="col-12 d-flex flex-column px-0 py-3">
                      <div class="row w-100">
                        <div
                          class="col-12 align-space-between border-blue align-text-plus px-0 pb-2"
                        >
                          <span class="tittle-card-style"
                            >Asistencia Legal y Fianza
                            </span
                          >
                          <span class="tittle-card-style tittle-circle">+</span>
                        </div>
                      </div>
                      <div class="row w-100 pt-3">
                        <div class="col-12 justify-content-start px-0">
                          <span
                            class="tittle-card-style"
                            style="font-weight: 500"
                            >Reporte policial, orden judicial, factura original del abogado y evidencia de pago.</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div
                class="card custom-card-middle-right custom-card-middle-blue-border border-grey background-grey shadow-lg"
              >
                <div class="card-body px-5 py-0 align-center-center">
                  <div class="row w-100 d-flex align-items-center pt-2">
                    <div class="col-12 d-flex flex-column px-0 py-3">
                      <div class="row w-100">
                        <div
                          class="col-12 align-space-between border-blue align-text-plus px-0 pb-2"
                        >
                          <span class="tittle-card-style"
                            >Asistencia Legal y Fianza
                            </span
                          >
                          <span class="tittle-card-style tittle-circle">+</span>
                        </div>
                      </div>
                      <div class="row w-100 pt-3">
                        <div class="col-12 justify-content-start px-0">
                          <span
                            class="tittle-card-style"
                            style="font-weight: 500"
                            >Reporte policial, orden judicial, factura original del abogado y evidencia de pago.</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="py-5"></div>
  <div class="home-container1">
    <div class="home-frame1084 w-100 slideBottomInUp">
      <div class="home-frame5511">
        <div class="home-frame549">
          <span class="home-text128 Mob,H1,Bold,14">
            <span>
              Blue Assist el seguro que se adapta a tus necesidades.
            </span>
          </span>
        </div>
        <div class="home-component421">
          <div class="home-frame9609">
            <div class="home-frame9711">
              <span
                class="home-text130 Mob,H2,Bold12"
                (click)="scrollTo('becausesection')"
              >
                <span>¿Por qué ?</span>
              </span>
            </div>
          </div>
        </div>
        <div class="home-component421">
          <div class="home-frame9610">
            <div class="home-frame9712">
              <span
                class="home-text130 Mob,H2,Bold12"
                (click)="scrollTo('benefitsecction')"
              >
                <span>Beneficios</span>
              </span>
            </div>
          </div>
        </div>
        <div class="home-component421">
          <div class="home-frame9611">
            <div class="home-frame9713">
              <span
                class="home-text130 Mob,H2,Bold12"
                (click)="scrollTo('optionSection')"
              >
                <span>Opcionales</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
